import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import * as React from 'react';
import { Link, navigate } from 'gatsby';
import { createPortal } from 'react-dom';
import styled, { x, createGlobalStyle } from '@xstyled/styled-components';
import { useDocSearchKeyboardEvents } from '@docsearch/react';
import { RiSearchLine } from 'react-icons/ri';
import { Input, InputGroup, InputGroupIcon } from './Input';
require('@docsearch/css');
const GlobalStyle = createGlobalStyle(["body.xstyled-color-mode-dark{--docsearch-text-color:rgb(245,246,247);--docsearch-container-background:rgba(9,10,17,0.8);--docsearch-modal-background:rgb(21,23,42);--docsearch-modal-shadow:inset 1px 1px 0 0 rgb(44,46,64),0 3px 8px 0 rgb(0,3,9);--docsearch-searchbox-background:rgb(9,10,17);--docsearch-searchbox-focus-background:#000;--docsearch-hit-color:rgb(190,195,201);--docsearch-hit-shadow:none;--docsearch-hit-background:rgb(9,10,17);--docsearch-key-gradient:linear-gradient( -26.5deg,rgb(86,88,114) 0%,rgb(49,53,91) 100% );--docsearch-key-shadow:inset 0 -2px 0 0 rgb(40,45,85),inset 0 0 1px 1px rgb(81,87,125),0 2px 2px 0 rgba(3,4,9,0.3);--docsearch-footer-background:rgb(30,33,54);--docsearch-footer-shadow:inset 0 1px 0 0 rgba(73,76,106,0.5),0 -4px 8px 0 rgba(0,0,0,0.2);--docsearch-logo-color:rgb(255,255,255);--docsearch-muted-color:rgb(127,132,151);}"]);
function Hit(_ref) {
  let {
    hit,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Link, {
    to: hit.url
  }, children);
}
const Kbd = styled.kbd.withConfig({
  displayName: "DocSearch__Kbd",
  componentId: "sc-z4bwrs-0"
})(["border:1;border-color:control-border;margin-right:1;background-color:control-background;text-align:center;padding:0;display:inline-flex;justify-content:center;font-size:0.8em;line-height:1.2;font-family:sans-serif;border-radius:base;min-width:1.5em;"]);
let DocSearchModal = null;
export const DocSearch = _ref2 => {
  let {
    apiKey,
    indexName,
    appId
  } = _ref2;
  const searchButtonRef = React.useRef(null);
  const [isShowing, setIsShowing] = React.useState(false);
  const [initialQuery, setInitialQuery] = React.useState(null);
  const importDocSearchModalIfNeeded = React.useCallback(() => {
    if (DocSearchModal) {
      return Promise.resolve();
    }
    return Promise.resolve(import('@docsearch/react/modal')).then(_ref3 => {
      let {
        DocSearchModal: Modal
      } = _ref3;
      DocSearchModal = Modal;
    });
  }, []);
  const onOpen = React.useCallback(() => {
    importDocSearchModalIfNeeded().then(() => {
      // We check that no other DocSearch modal is showing before opening this
      // one (we use one instance for desktop and one instance for mobile).
      if (document.body.classList.contains('DocSearch--active')) {
        return;
      }
      setIsShowing(true);
    });
  }, [importDocSearchModalIfNeeded, setIsShowing]);
  const onClose = React.useCallback(() => {
    setIsShowing(false);
  }, [setIsShowing]);
  const onInput = React.useCallback(event => {
    importDocSearchModalIfNeeded().then(() => {
      setIsShowing(true);
      setInitialQuery(event.key);
    });
  }, [importDocSearchModalIfNeeded, setIsShowing, setInitialQuery]);
  useDocSearchKeyboardEvents({
    isOpen: isShowing,
    onOpen,
    onClose,
    onInput,
    searchButtonRef
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(InputGroupIcon, null, /*#__PURE__*/React.createElement(RiSearchLine, null)), /*#__PURE__*/React.createElement(Input, {
    ref: searchButtonRef,
    onClick: onOpen,
    type: "search",
    placeholder: "Search..."
  }), /*#__PURE__*/React.createElement(x.div, {
    position: "absolute",
    top: "50%",
    right: 0,
    transform: "translateY(-50%)",
    display: "inline-flex",
    pointerEvents: "none",
    userSelect: "none"
  }, /*#__PURE__*/React.createElement(Kbd, null, "\u2318"), /*#__PURE__*/React.createElement(Kbd, null, "K")))), isShowing && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(DocSearchModal, {
    apiKey: apiKey,
    indexName: indexName,
    appId: appId !== null && appId !== void 0 ? appId : 'BH4D9OD16A',
    initialQuery: initialQuery,
    onClose: onClose,
    navigator: {
      navigate(_ref4) {
        let {
          suggestionUrl
        } = _ref4;
        navigate(suggestionUrl);
      }
    },
    transformItems: items => {
      return items.map(item => {
        const url = new URL(item.url);
        return _objectSpread(_objectSpread({}, item), {}, {
          url: item.url.replace(url.origin, '')
        });
      });
    },
    hitComponent: Hit
  }), document.body));
};